<div class="dd-wrap">

  <!-- ── Filtros (generados desde la config) ────────────────────────────── -->
  @if (boardConfig) {
    <div class="dd-filters">
      @for (f of boardConfig.filters; track f.key) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ f.label }}</mat-label>
          <mat-select
            [value]="filterValues[f.key]"
            (selectionChange)="onFilterChange(f.key, $event.value)">

            @if (f.source === 'from_card') {
              <mat-option value="all">Todos los {{ f.label }}</mat-option>
            }

            @for (opt of filterOptions[f.key]; track opt) {
              <mat-option [value]="opt">{{ opt }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  }

  <!-- ── Loading / Error ────────────────────────────────────────────────── -->
  @if (loading) {
    <div class="dd-state">Cargando datos...</div>
  } @else if (error) {
    <div class="dd-state dd-state--error">No se pudo cargar el dashboard.</div>
  } @else {

    <!-- ── Secciones dinámicas ───────────────────────────────────────────── -->
    @for (section of sections; track section.id; let si = $index) {

      <!-- Cabecera de librería -->
      @if (section.library && section.library !== 'none') {
        <div class="dd-lib-header dd-lib-header--{{ section.library }}"
             [style.margin-top]="si > 0 ? '48px' : '24px'">
          <span class="dd-lib-badge dd-lib-badge--{{ section.library }}">
            {{ section.library === 'echarts' ? 'ECharts'
             : section.library === 'chartjs' ? 'Chart.js'
             : section.library }}
          </span>
        </div>
      }

      <!-- Título de sección -->
      @if (section.title) {
        <h3 class="dd-section">{{ section.title }}</h3>
      }

      <!-- Grid de cards -->
      <div class="dd-grid">
        @for (card of section.cards; track card.cfg.title) {
          <div class="dd-cell dd-cell--{{ card.layout }}">

            @switch (card.kind) {

              @case ('dark-stats') {
                <app-dark-stats-card [config]="card.cfg" />
              }

              @case ('echart') {
                <app-echart-card [config]="card.cfg" />
              }

              @case ('chartjs') {
                <app-chartjs-card [config]="card.cfg" />
              }

            }
          </div>
        }
      </div>

    }
  }

</div>
